import React, { useState, useEffect } from "react";
import { useMaterialUIController } from "context";
import getText from "Translator";

import Swal from "sweetalert2";
import { displayErrorMessage } from "controllers/validation";
import { displaySuccessMessage } from "controllers/validation";
import { storePage } from "controllers/MenuController";
import { updatePage } from "controllers/MenuController";
import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
} from "@mui/material";
import LoadingOverlay from "react-loading-overlay";

const NewPage = (props) => {
  const [controller] = useMaterialUIController();
  const [isSecretary, setIsSecretary] = useState(true);
  const [text, setText] = useState("");
  const { handleClose, getData, mode, form, id } = props;
  const [loading, setLoading] = useState(false);

  const SubmitPageHandler = async () => {
    try {
      if (mode === "newpage") {
        let newPage = {
          form: form,
          text,
          isSecretary,
        };
        setLoading(true);
        let data = await storePage(controller.lang, newPage, controller.token);
        setLoading(false);
        if (data.success) {
          console.log("datadata", data);
          displaySuccessMessage(controller.lang, data.message);
          handleClose();
          getData();
        } else {
          displayErrorMessage(controller.lang, data.message);
        }
      } else {
        editPage();
      }
    } catch (err) {
      displayErrorMessage(controller.lang);
    }
  };
  const editPage = async () => {
    try {
      let newPage = {
        page: id,
        form: form,
        text,
        isSecretary,
        lang: controller.lang,
      };
      setLoading(true);
      let data = await updatePage(controller.lang, newPage, controller.token);
      setLoading(false);
      if (data.success) {
        displaySuccessMessage(controller.lang, data.message);
        handleClose();
        getData();
      } else {
        displayErrorMessage(controller.lang, data.message);
      }
    } catch (err) {
      displayErrorMessage(controller.lang);
    }
  };
  useEffect(() => {
    setText("");

    if (mode === "editpage") {
      setIsSecretary(props.isSecretary);
      setText(props.text);
    }
  }, []);
  return (
    <Grid container>
      <LoadingOverlay
        active={loading}
        spinner
        text={getText("loading", controller.lang)}
      >
        <Grid item xs={12} sm={12} md={12}>
          {getText("text", controller.lang)}
          <TextField
            style={{ minWidth: 350 }}
            id="text"
            fullWidth
            variant="outlined"
            value={text}
            onChange={(event) => {
              setText(event.target.value);
            }}
          />
        </Grid>

        <Grid item xs={12} sm={12} md={12} style={{ margginTop: 15 }}>
          {/* <FormControlLabel
            control={
              <Checkbox
                checked={isSecretary}
                onChange={() => setIsSecretary(!isSecretary)}
                name="chbisSecretary"
              />
            }
            label={getText("showforsecretary", controller.lang)}
          />*/}
        </Grid> 
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          style={{
            flexDirection: "row",
            textAlign: controller.direction == "ltr" ? "right" : "left",
          }}
        >
          <Button color="secondary" onClick={handleClose}>
            {getText("cancel", controller.lang)}
          </Button>
          <Button color="primary" onClick={SubmitPageHandler}>
            {getText("submit", controller.lang)}
          </Button>
        </Grid>
      </LoadingOverlay>
    </Grid>
  );
};
export default NewPage;
